/**
 * Resolves where to send a user after a successful sign-in. Anonymous visitors who follow a
 * protected link (e.g. a shared `/game/{id}`) are bounced to `/login?returnUrl=...`; this reads
 * that param back and returns it only when it's a safe, same-origin relative path — otherwise the
 * caller's fallback (the lobby). Guarding against absolute/protocol-relative values prevents an
 * open-redirect off the back of sign-in.
 */
export function resolveReturnUrl(search: string, fallback = '/lobby'): string {
  const candidate = new URLSearchParams(search).get('returnUrl');
  if (!candidate || !isSafeLocalPath(candidate)) {
    return fallback;
  }
  return candidate;
}

/** A local path: starts with a single "/", and isn't "//" or "/\" (protocol-relative escapes). */
function isSafeLocalPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
}
